let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("edAvt")).then(() => parcelRequire('d5oAD'));